<template>
  <div class="conteudoInterno" id="distribuicao">
    <div class="boxSeta">
      <div
        class="setaScrollstatic"
        style=""
        :class="{
          setaScroll: setaScrollState,
        }"
      >
        <button>
          <span><i class="bottom"></i></span>
        </button>
      </div>
    </div>
    <header class="headerSec">
      <h2>Distribuição</h2>
      <div class="navSetas">
        <button @click="goBack()" :disabled="clicked">
          <span><i class="left"></i></span>
        </button>
        <button @click="goNext()" :disabled="clicked">
          <span><i class="right"></i></span>
        </button>
      </div>
    </header>
    <div class="conteudoInternoBox" ref="infoBox">
      <section class="sectionRow" ref="infoscroll">
        <div class="col23ponto5 marginColBottom">
          <span class="linecol ubcPinkBack"></span>
        </div>
        <div class="col66 top32">
          <p>
            A principal finalidade do sistema de gestão coletiva é garantir que os criadores recebam pelo uso de suas obras. Para alcançar esse fim em uma contínua era de crescente quantidade de dados a serem processados —, a UBC mantém um trabalho constante de revisão e aperfeiçoamento na documentação das obras, tanto em seu próprio banco de dados quanto no do Ecad. 
          </p>
          <p>
            Os dados apresentados nesta seção têm como base a distribuição total do Ecad e oferecem um retrato fiel do cenário brasileiro da execução pública como um todo.
          </p>
        </div>
      </section>
      <section class="sectionRow top50">
        <div class="col23ponto5"></div>
        <div class="col66">
          <h4 class="h4Destaque">
            O valor total distribuído em 2024 foi de
            <span class="ubcPink Green sanukBlack">R$ 1.483.203.096,73</span> – 
            um
            <span class="ubcPink Green sanukBlack">crescimento de 12,83%</span> em
            relação ao ano anterior.
          </h4>
        </div>
      </section>
      <section class="sectionRow top120">
        <div class="col32">
          <h3>Evolução das cifras de distribuição</h3>
          <div class="evolucaoDistribuicao top20">
            <span>2020</span>
            <h4 class="sanukBlack ubcPink">R$ 947.928.688</h4>
          </div>
          <div class="evolucaoDistribuicao">
            <span>2021</span>
            <h4 class="sanukBlack ubcPink">R$ 901.588.852</h4>
          </div>
          <div class="evolucaoDistribuicao">
            <span>2022</span>
            <h4 class="sanukBlack ubcPink">R$ 1.232.071.471</h4>
          </div>
          <div class="evolucaoDistribuicao">
            <span>2023</span>
            <h4 class="sanukBlack ubcPink">R$ 1.390.932.883</h4>
          </div>
          <div class="evolucaoDistribuicao">
            <span>2024</span>
            <h4 class="sanukBlack ubcPink">R$ 1.483.203.096,73</h4>
          </div>
          <p>
            Em 2024, foram <span class="sanukBold"
            >contemplados 345.836 titulares, representando um aumento 6,22% em relação ao ano de 2023.</span> 69% foram estrangeiros e 31% nacionais, entre autores/compositores, editores, músicos, intérpretes e gravadoras
          </p>
        </div>
        <div class="col57ponto6 topMob32">
          <h3>Participação na distribuição, por categoria</h3>
          <SwipperMobile />
          <div class="graphContainer">
            <div class="graph">
              <BarChart />
            </div>
          </div>
          <!-- <div class="top20">
            <PieChart2 />
          </div> -->
          <!-- <p class="note top20">
            Nota: os royalties arrecadados de Usuários Gerais para os quais não existem dados de uso disponíveis são somados às distribuições tanto de TV aberta como de Rádio, com uma divisão de distribuição de 5%/95%, respectivamente.
          </p> -->
          
        </div>
      </section>
      <section class="sectionRow top120">
        <div class="col100">
          <h3>
            Detalhamento da distribuição por tipo de direitos: autorais vs.
            conexos
          </h3>
          <SwipperMobile />
          <div class="top20 tableContainer">
            <table>
              <thead>
                <tr>
                  <th align="left">
                    <span class="sanukBold">Categorias</span>
                  </th>
                  <th colspan="3" align="center">
                    <span class="sanukBold">Autorais</span>
                  </th>
                  <th colspan="3" align="center">
                    <span class="sanukBold">Conexos</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td></td>
                  <td align="right" class="subColYear">2023</td>
                  <td align="right" class="subColYear">2024</td>
                  <td align="right" class="subColYear">%</td>
                  <td align="right" class="subColYear">2023</td>
                  <td align="right" class="subColYear">2024</td>
                  <td align="right" class="subColYear">%</td>
                </tr>
                <tr>
                  <td>Carnaval</td>
                  <td align="right">R$ 19.836.799,46</td>
                  <td align="right">R$ 22.126.250,95</td>
                  <td align="right">11,54%</td>
                  <td align="right">R$ 1.051.555,42</td>
                  <td align="right">R$ 1.182.584,46</td>
                  <td align="right">12,46%</td>
                </tr>
                <tr>
                  <td>Casas de Festas e Diversão</td>
                  <td align="right">R$ 24.633.271,06</td>
                  <td align="right">R$ 28.207.894,91</td>
                  <td align="right">14,51%</td>
                  <td align="right">R$ 15.996.819,93</td>
                  <td align="right">R$ 18.317.864,37</td>
                  <td align="right">14,51%</td>
                </tr>
                <tr>
                  <td>Cinema</td>
                  <td align="right">R$ 15.064.242,45</td>
                  <td align="right">R$ 20.216.750,99</td>
                  <td align="right">34,2%</td>
                  <td align="right">R$ 6.356.416,43</td>
                  <td align="right">R$ 19.636.461,14</td>
                  <td align="right">208,92%</td>
                </tr>
                <tr>
                  <td>Demais Segmentos</td>
                  <td align="right">R$ 3.001.242,78</td>
                  <td align="right">R$ -40.152,77</td>
                  <td align="right">-101,34%</td>
                  <td align="right">R$ 4.884.567,96</td>
                  <td align="right">R$ 997.09</td>
                  <td align="right">-99,98%</td>
                </tr>
                <tr>
                  <td>Festa Junina</td>
                  <td align="right">R$ 4.774.851,72</td>
                  <td align="right">R$ 5.263.673,78</td>
                  <td align="right">10,24%</td>
                  <td align="right">R$ 480.511,69</td>
                  <td align="right">R$ 500.943,10</td>
                  <td align="right">4,25%</td>
                </tr>
                <tr>
                  <td>Música ao Vivo</td>
                  <td align="right">R$ 36.233.743,78</td>
                  <td align="right">R$ 41.181.299,65</td>
                  <td align="right">13,65%</td>
                  <td align="right">-</td>
                  <td align="right">-</td>
                  <td align="right">-</td>
                </tr>
                <tr>
                  <td>Rádios+DG</td>
                  <td align="right">R$ 175.074.624,64</td>
                  <td align="right">R$ 186.327.709,86</td>
                  <td align="right">6,43%</td>
                  <td align="right">R$ 85.702.797,29</td>
                  <td align="right">R$ 92.737.605,99</td>
                  <td align="right">8,21%</td>
                </tr>
                <tr>
                  <td>Serviços Digitais*</td>
                  <td align="right">R$ 6.124.404,75</td>
                  <td align="right">R$ 5.988.473,42</td>
                  <td align="right">-2,22%</td>
                  <td align="right">R$ 3.084.229,25</td>
                  <td align="right">R$ 2.994.399,53</td>
                  <td align="right">-2,91%</td>
                </tr>
                <tr>
                  <td>Shows</td>
                  <td align="right">R$ 155.265.406,69</td>
                  <td align="right">R$ 207.195.319,54</td>
                  <td align="right">33,45%</td>
                  <td align="right">-</td>
                  <td align="right">-</td>
                  <td align="right">-</td>
                </tr>
                <tr>
                  <td>Sonorização Ambiental</td>
                  <td align="right">R$ 39.827.910,72</td>
                  <td align="right">R$ 43.456.416,86</td>
                  <td align="right">9,11%</td>
                  <td align="right">19.858.051,47</td>
                  <td align="right">21.346.908,56</td>
                  <td align="right">7,5%</td>
                </tr>
                <tr>
                  <td>Streaming de áudio</td>
                  <td align="right">R$ 129.206.030,67</td>
                  <td align="right">R$ 151.626.914,37</td>
                  <td align="right">17,35%</td>
                  <td align="right">R$ 402.557,18</td>
                  <td align="right">R$ 3.341.286,16</td>
                  <td align="right">730,02%</td>
                </tr>
                <tr>
                  <td>Streaming de vídeo</td>
                  <td align="right">R$ 146.201.129,99</td>
                  <td align="right">R$ 177.745.230,08</td>
                  <td align="right">21,58%</td>
                  <td align="right">R$ 9.267.931,63</td>
                  <td align="right">R$ 10.946.643,26</td>
                  <td align="right">18,11%</td>
                </tr>
                <tr>
                  <td>Tv Aberta+DG</td>
                  <td align="right">R$ 157.715.981,08</td>
                  <td align="right">R$ 158.271.783,57</td>
                  <td align="right">0,35%</td>
                  <td align="right">R$ 81.501.933,31</td>
                  <td align="right">R$ 82.355.426,50</td>
                  <td align="right">1,05%</td>
                </tr>
                <tr>
                  <td>Tv Fechada</td>
                  <td align="right">R$ 111.788.830,83</td>
                  <td align="right">R$ 114.544.074,82</td>
                  <td align="right">2,46%</td>
                  <td align="right">R$ 61.332.683,02</td>
                  <td align="right">R$ 67.729.450,49</td>
                  <td align="right">10,43%</td>
                </tr>
                <tr>
                  <td><span class="sanukBold">Total</span></td>
                  <td align="right"><span class="sanukBold">R$ 1.024.750.493,62</span></td>
                  <td align="right"><span class="sanukBold">R$ 1.162.113.664,03</span></td>
                  <td align="right"><span class="sanukBold">-</span></td>
                  <td align="right"><span class="sanukBold">R$ 289.922.077,59</span></td>
                  <td align="right"><span class="sanukBold">R$ 321.090.570,65</span></td>
                  <td align="right"><span class="sanukBold">-</span></td>
                </tr>
              </tbody>
            </table>
          </div>
          <p class="tableNote" style="margin-bottom: 1rem">
            *os royalties arrecadados de Usuários Gerais para os quais não existem dados de uso disponíveis são somados às distribuições tanto de TV aberta como de Rádio, com uma divisão de distribuição de 5%/95%, respectivamente.
          </p>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { ShareFunctions } from "../assets/js/functions.js";
// import PieChart2 from "./Grafico3.vue";
import BarChart from "./Grafico4.vue";
import SwipperMobile from "./SwipperMobile.vue";

export default {
  name: "DistribuicaoPage",
  props: ["clicked"],
  components: {
    // PieChart2,
    BarChart,
    SwipperMobile
     },
  data() {
    return {
      setaScrollState: false,
    };
  },
  destroyed() {
    this.myStopFunction();
  },
  mounted() {
    this.showSetaScroll();

    const conteudo = document.querySelector("#distribuicao");
    conteudo.addEventListener("scroll", ShareFunctions.headerScroll);
  },
  methods: {
    showSetaScroll: function () {
      this.refresh = setInterval(() => {
        let alturaTela = window.innerHeight;
        let alturaDiv = this.$refs.infoBox.clientHeight;
        let boxABB = this.$refs["infoscroll"].getBoundingClientRect();
        if (alturaTela - 50 <= alturaDiv && boxABB.top == 148) {
          this.setaScrollState = true;
        } else {
          this.setaScrollState = false;
        }
      }, 1000);
    },
    myStopFunction: function () {
      clearInterval(this.refresh);
    },
    goNext: function () {
      this.$emit("go-next");
    },
    goBack: function () {
      this.$emit("go-back");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.evolucaoDistribuicao h4 {
  font-size: 24px;
  margin-bottom: 8px;
}
.evolucaoDistribuicao:nth-child(3) h4 {
  font-size: 27px;
  margin-bottom: 8px;
}
.evolucaoDistribuicao:nth-child(4) h4 {
  font-size: 30px;
  margin-bottom: 8px;
}
.evolucaoDistribuicao:nth-child(5) h4 {
  font-size: 33px;
  margin-bottom: 8px;
}
.evolucaoDistribuicao:nth-child(6) h4 {
  font-size: 36px;
}
.note {
  padding-left: 160px;
}

.graphContainer {
  padding-top: 30px;
  width: 100%;
  overflow-x: scroll;
}

.graphContainer::-webkit-scrollbar
{
  background-color: white;
  border-radius: 10px;
  width: 20px;
}

.graphContainer::-webkit-scrollbar-thumb
{
  background-color: #EC1651;
  border-radius: 10px;
  border: 5px solid white;
}

.tableNote {
  font-size: 12px;
  line-height: 18px;
}

.tableNote:first-of-type {
  margin-top: 20px;
  margin-bottom: unset;
}

.graph {
  min-width: 500px;
  min-height: 400px;
}

table {
  border: none;
  border-collapse: collapse;
  margin: 0;
  padding: 0;
  width: 100%;
  table-layout: fixed;
  font-size: 14px;
  min-width: 1024px;
}

table thead {
  background-color: #ec1651;
  color: #fff;
}

table thead tr th {
  padding: 15px 0;
  vertical-align: middle;
}

table thead tr th:first-child {
  padding-left: 2%;
}
table thead tr th:last-child {
  padding-right: 2%;
}

table tbody tr:nth-child(even) {
  background-color: #f6f6f6;
}

table tbody tr td {
  padding: 15px 0;
  vertical-align: middle;
  font-size: 12px;
}

table tbody tr {
  position: relative;
}

table tbody tr td:first-child {
  padding-left: 2%;
  position: sticky;
  left: 0;
  background: #fff;
}

table tbody tr:nth-child(even) td:first-child {
  background-color: #f6f6f6;
}

table tbody tr td:last-child {
  padding-right: 2%;
}

.tableNote {
  font-size: 12px;
  line-height: 18px;
}

.tableNote:first-of-type {
  margin-top: 20px;
  margin-bottom: unset;
}

.subColYear {
  font-family: "sanuk-bold";
  color: #ec1651;
}

@media screen and (max-width: 1200px) {
  .tableContainer{
    overflow-x: scroll;
  }
}

@media screen and (max-width: 500px) {
  .note {
    padding-left: 0;
  }
}
</style>
